<template></template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DashboardHandler',

    methods: {
        clientName(client) {
            const maxLength = 20
            return client.name.length > maxLength
                ? `${client.name.substring(0, maxLength)}...`
                : client.name
        },

        handleHomeRoute(client) {
            let html = ''
            html += `<a href="${client.home_route}" title="Page d'accueil de la société ${client.name}">`
            html += this.clientName(client)
            html += '</a>'
            return html
        },

        handleSettingRoute(client) {
            let html = ''
            html += `<a href="${client.setting_route}" title="Paramétrer la société ${client.name}">`
            html += this.clientName(client)
            html += '</a>'
            return html
        },

        handleDeadlinesRoute(client, filter) {
            this.$store.commit('browsing/SET_DEADLINES_TABLE_FILTER', filter)
            let html = ''
            html += `<a href="${client.deadlines_route}" title="Modifier les échéances">`
            html += '<i class="fas fa-calendar fa-fw text-secondary"></i>'
            html += '</a>'
            return html
        },

        handleHistoryRoute(client) {
            let html = ''
            html += `<a href="${client.history_route}" title="Ajouter un commentaire">`
            html += '<i class="fas fa-book fa-fw text-secondary"></i>'
            html += '</a>'
            return html
        },

        handlePvGeneratorRoute(client) {
            let html = ''
            html += `<a href="${client.pv_generator_route}" title="Générer et télécharger le PV">`
            html += '<i class="fas fa-file-word fa-fw text-secondary"></i>'
            html += '</a>'
            return html
        },

        handleEmail(email) {
            let html = ''
            if (email !== null) {
                html += `<a href="mailto:${email}?body=Bonjour,%0D%0A..."`
                html += ' title="Envoyer un mail au contact">'
                html += '<i class="fas fa-envelope fa-fw text-secondary"></i>'
                html += '</a>'
            }
            return html
        },

        handleTimeSheetEmail(email) {
            let html = ''
            if (email !== null) {
                html += `<a href="mailto:${email}?subject=Saisie%20des%20temps&body=Bonjour,%0D%0A..."`
                html += ' title="Envoyer un mail au collaborateur">'
                html += '<i class="fas fa-envelope fa-fw text-secondary"></i>'
                html += '</a>'
            }
            return html
        },

        resetMonthData(client_id, month) {
            this.updateMonthData(client_id, month, true)
        },

        updateMonthData(client_id, month, reset) {
            // initialise array
            const itemsArray = this.items

            // find index for this client_id
            const objIndex = itemsArray.findIndex(
                (obj) => obj.client_id === client_id
            )

            switch (month) {
                case 1:
                    itemsArray[objIndex].m1 = reset ? [] : this.updatedItem.m1
                    break
                case 2:
                    itemsArray[objIndex].m2 = reset ? [] : this.updatedItem.m2
                    break
                case 3:
                    itemsArray[objIndex].m3 = reset ? [] : this.updatedItem.m3
                    break
                case 4:
                    itemsArray[objIndex].m4 = reset ? [] : this.updatedItem.m4
                    break
                case 5:
                    itemsArray[objIndex].m5 = reset ? [] : this.updatedItem.m5
                    break
                case 6:
                    itemsArray[objIndex].m6 = reset ? [] : this.updatedItem.m6
                    break
                case 7:
                    itemsArray[objIndex].m7 = reset ? [] : this.updatedItem.m7
                    break
                case 8:
                    itemsArray[objIndex].m8 = reset ? [] : this.updatedItem.m8
                    break
                case 9:
                    itemsArray[objIndex].m9 = reset ? [] : this.updatedItem.m9
                    break
                case 10:
                    itemsArray[objIndex].m10 = reset ? [] : this.updatedItem.m10
                    break
                case 11:
                    itemsArray[objIndex].m11 = reset ? [] : this.updatedItem.m11
                    break
                case 12:
                    itemsArray[objIndex].m12 = reset ? [] : this.updatedItem.m12
                    break
            }
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            deadlineFilter: (state) => state.browsing.deadlineFilter,
        }),

        filteredItems() {
            if (this.deadlineFilter === 'late') {
                return this.lateItems
            }
            if (this.deadlineFilter === 'soon') {
                return this.soonItems
            }
            if (this.deadlineFilter === 'done') {
                return this.doneItems
            }
            return this.items
        },

        lateItems() {
            return this.items.filter((item) => item.late)
        },

        soonItems() {
            return this.items.filter((item) => item.soon)
        },

        doneItems() {
            return this.items.filter((item) => item.done)
        },
    },
}
</script>

<style scoped></style>
